<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<h1 class="chapter">2</h1>
<h1 class="chapter1">ACORNS</h1>
<p class="indent">The well-known fruit of the oak has long ceased to be so important as it was in ancient times. When Britain, for instance, sparsely inhabited, was densely covered by forest, chiefly oak, there is little doubt that acorns formed a not inappreciable portion of the food of the natives. Burnet, writing of the oak, observed: ‘It is celebrated in story and in song, in the forest and in the field; and is unrivalled in commerce and in the arts. It was held sacred alike by the Hebrews, the Greeks and the Romans, the Ancient Britons and the Gauls, and it was the fear of the superstitious for their oracle at the same time that it was the resort of the hungry for their food.’</p>
<p class="indent">This reference to the food obtainable from the oak alludes, no doubt, to the acorn. Loudon remarks: ‘Among the Greeks the Arcadians believed that the oak was the first created of trees, and that they were the first people; but, according to others, the oaks which produced the acorns first eaten by men grew on the banks of Achelous. Pelasgus taught the Greeks to eat acorns, as well as to build huts.’</p>
<p class="indent">Reference in the Bible to the woods of Bashan and to the rearing and feeding of cattle and swine point clearly to the acorn; for there was, and is, no other food obtainable from the oak. Hogs in those ancient days, as subsequently, were fed upon acorns; but then acorns were a staple of the food.</p>
<p class="indent">Laws were enacted to provide for proprietary rights in acorns; and by those laws it was, amongst other things, laid down that the owner of an oak might gather up his own oak’s acorns, notwithstanding that they fell on another man’s land. This regulation (very different from present British law, which gives to a neighbour any part of a tree hanging over that neighbour’s land) indicates indirectly the marvellously spreading habit of oak limbs.</p>
<p class="indent">It is a curious fact that, notwithstanding the great longevity of the oak, extending, it is known, beyond 1,650 years, the vitality of the acorn is less than that of almost any other seed, and very few germinate after keeping for more than a year.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c02.vue?b375a820